let scriptPromise: Promise<void> | null = null;

const loadCaptcha = async (): Promise<GrecaptchaEnterprise> => {
    if (globalThis.window === undefined || globalThis.document === undefined) {
        throw new TypeError('reCAPTCHA Enterprise is not available');
    }

    if (!globalThis.window?.grecaptcha?.enterprise) {
        scriptPromise ??= new Promise<void>((resolve, reject) => {
            const script = document.createElement('script');
            script.src = `https://www.google.com/recaptcha/enterprise.js?render=${process.env.GATSBY_CAPTCHA_SITE_KEY}`;
            script.async = true;
            script.defer = true;
            script.onload = () => resolve();
            script.onerror = () => {
                scriptPromise = null;
                reject(new Error('Failed to load reCAPTCHA Enterprise'));
            };
            document.head.appendChild(script);
        });

        await scriptPromise;
    }

    const enterprise = globalThis.window?.grecaptcha?.enterprise;

    if (!enterprise) {
        throw new Error('reCAPTCHA Enterprise is not available');
    }

    await new Promise<void>((resolve) => enterprise.ready(resolve));

    return enterprise;
};

export const getCaptchaToken = async (): Promise<string> => {
    if (!process.env.GATSBY_CAPTCHA_SITE_KEY) {
        return '';
    }

    const enterprise = await loadCaptcha();

    // Action must match backend `config.CAPTCHA.ACTION.CREATE_APIKEY` exactly.
    const token = await enterprise.execute(process.env.GATSBY_CAPTCHA_SITE_KEY, { action: 'create_apikey' });

    if (!token) {
        throw new Error('Failed to generate reCAPTCHA Enterprise token');
    }

    return token;
};
